import { useLocation } from "react-router-dom";

export const useIsNavActive = (path: string, aliases: string[] = []): boolean => {
    const { pathname } = useLocation();

    // normalize pathname (remove trailing slash)
    const cleanPath = pathname.endsWith("/") && pathname.length > 1
        ? pathname.slice(0, -1)
        : pathname;

    if (cleanPath === path) return true;
    if (aliases.includes(cleanPath)) return true;

    return false;
};
